import React from "react";
import { ADVANCE_HIGHLIGHT_PARTNAMES, HIGHLIGHT_WORDS } from "./advanceConfig";

const HIGHLIGHT_PATTERN = new RegExp(`(${HIGHLIGHT_WORDS.join("|")})`, "g");

export const renderHighlightedPartDes = (partname, partdes) => {
  if (!partdes || !ADVANCE_HIGHLIGHT_PARTNAMES.includes(partname)) {
    return partdes;
  }

  return partdes.split(HIGHLIGHT_PATTERN).map((part, i) =>
    HIGHLIGHT_WORDS.includes(part) ? (
      <span key={i} style={{ color: "red", fontWeight: "bold" }}>
        {part}
      </span>
    ) : (
      part
    ),
  );
};
